import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const { Title } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const result = await login(values.username, values.password);
      if (result.success) {
        navigate('/');
      } else {
        message.error(result.error || 'Giriş başarısız');
      }
    } catch (error) {
      message.error('Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="login-container"
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '16px',
      }}
    >
      <Card
        className="login-card"
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} className="login-title" style={{ color: '#1890ff', fontSize: window.innerWidth <= 768 ? '20px' : '24px' }}>
            Flexer Server
          </Title>
          <Title level={4} className="login-subtitle" style={{ color: '#666', fontSize: window.innerWidth <= 768 ? '16px' : '18px' }}>
            Giriş Yapın
          </Title>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          size={window.innerWidth <= 768 ? 'large' : 'large'}
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: 'Lütfen kullanıcı adınızı girin!',
              },
            ]}
          >
            <Input
              className="login-input"
              prefix={<UserOutlined />}
              placeholder="Kullanıcı Adı"
              size="large"
              style={{ 
                height: window.innerWidth <= 768 ? '48px' : '40px',
                fontSize: window.innerWidth <= 768 ? '16px' : '14px'
              }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: 'Lütfen şifrenizi girin!',
              },
            ]}
          >
            <Input.Password
              className="login-input"
              prefix={<LockOutlined />}
              placeholder="Şifre"
              size="large"
              style={{ 
                height: window.innerWidth <= 768 ? '48px' : '40px',
                fontSize: window.innerWidth <= 768 ? '16px' : '14px'
              }}
            />
          </Form.Item>

          <Form.Item>
            <Button
              className="login-button"
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              block
              style={{ 
                height: window.innerWidth <= 768 ? '48px' : '40px',
                fontSize: window.innerWidth <= 768 ? '16px' : '14px'
              }}
            >
              Giriş Yap
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
